// extracted by mini-css-extract-plugin
export default {"header":"ConfirmationDialog_header__iTjOy","footer":"ConfirmationDialog_footer__X+Wqp","error":"ConfirmationDialog_error__Q75ak"};